import axios from 'axios'

const { REACT_APP_INNOVARISK_API } = process.env

export const axiosInstance = axios.create({
  baseURL: `${REACT_APP_INNOVARISK_API}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})
